import axios from 'axios';
import useAuth from './useAuth';

const useRefreshToken = () => {
    const { setAuth } = useAuth();

    const refresh = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/refresh-token`, // Use env variable
                {
                    withCredentials: true,
                    timeout: 5000
                }
            );

            if (!response.data?.accessToken) {
                throw new Error('Invalid token response');
            }

            const newAccessToken = response.data.accessToken;

            setAuth(prev => ({
                ...prev, // Preserve existing auth state
                isAuthenticated: true,
                accessToken: newAccessToken,
                tokenExpiry: Date.now() + (15 * 60 * 1000) // Optional: Track expiry (15 mins)
            }));

            // For debugging
            console.log('Token refresh successful', {
                newToken: newAccessToken?.slice(-10) + '...',
                expiry: new Date(Date.now() + 15 * 60 * 1000).toLocaleTimeString()
            });

            return newAccessToken;
        } catch (error) {
            console.error("Refresh token failed - clearing auth", {
                error: error.response?.status || error.message
            });

            // Full auth reset
            setAuth({
                isAuthenticated: false,
                user: null,
                user_id: null,
                group_id: null,
                group_name: null,
                permissions: [],
                accessToken: null,
                tokenExpiry: null
            });

            // Clear any potential residual cookies
            document.cookie = 'refreshToken=; Max-Age=0; path=/; secure; samesite=strict';

            throw new Error('Session expired - Please login again');
        }
    };

    return refresh;
};

export default useRefreshToken;